{
  "currentPlan": "Current Plan",
  "trialExpired": "Expired",
  "title": "Log Analysis Pricing",
  "trialPlanCallout": "Your free trial will expire in <strong>{{count}} day</strong>. After this time, data will only be available in the Live Tail. Upgrade to Professional now.",
  "trialPlanCallout_plural": "Your free trial will expire in  <strong>{{count}} days</strong>. After this time, data will only be available in the Live Tail. Upgrade to Professional now.",
  "trialPlanAboutToExpireCallout": "Your free trial plan is <strong>about to expire</strong>. After this time, data will only be available in the Live Tail. Upgrade to Professional now.",
  "enterprisePlanCallout": "For any questions about your plan, please contact your Customer Success Manager directly, or  <a href='mailto:csm@$t(common:defaultHost)'>CSM@$t(common:defaultHost)</a>.",
  "community": {
    "title": "Community",
    "description": "No retention",
    "price": "Free",
    "pointsTitle": "Perfect for hobbyists",
    "points": {
      "seats": "25 users",
      "retention": "No retention",
      "liveTail": "Live Tail + Views",
      "automaticParsing": "Automatic Parsing"
    }
  },
  "pro": {
    "title": "Professional",
    "price": "${{price}}/GB",
    "priceDescription": "Per month",
    "retention": "{{retention}} - Day Retention",
    "pointsTitle": "Ideal for growing teams",
    "points": {
      "seats": "25 users",
      "retention": "3, 7, 14, or 30 day retention",
      "liveTail": "Live Tail + Views",
      "parsing": "Automatic + Custom Parsing",
      "usageControl": "Usage control features",
      "alerts": "Alerts via Slack, Email, Webhook, PagerDuty and more",
      "restoration": "Log Data Restoration"
    },
    "notes": {
      "minCharge": "* Minimum charge ${{minCharge}}"
    }
  },
  "enterprise": {
    "title": "Enterprise",
    "description": "Tailored to your needs",
    "price": "Custom",
    "priceDescription": "Annual Contract",
    "pointsTitle": "Designed for Enterprises",
    "pointsDescription": "Everything in Professional, plus:",
    "points": {
      "seats": "Unlimited users",
      "orgs": "Multiple organizations",
      "variableRetention": "Variable Retention",
      "kubernetes": "Kubernetes Enrichment",
      "SSO": "SSO and SAML",
      "HIPAA": "HIPAA Compliance"
    },
    "contactSales": "Contact Sales"
  },
  "moreDetails": "Visit our <a href='https://www.$t(common:defaultHost)/pricing'>pricing page</a> to compare plans in more details. For any billing questions feel free to ",
  "contactUs": "contact us",
  "pipeline": {
    "trialPlanCallout": "Your free trial will expire in <strong>{{count}} day</strong>. Upgrade to Professional now.",
    "trialPlanCallout_plural": "Your free trial will expire in  <strong>{{count}} days</strong>. Upgrade to Professional now.",
    "trialPlanAboutToExpireCallout": "Your free trial plan is <strong>about to expire</strong>. Upgrade to Professional now.",
    "title": "Telemetry Pipeline Pricing",
    "trial": {
      "automaticInDays": "Automatic in {{count}} day",
      "automaticInDays_plural": "Automatic in {{count}} days",
      "automaticSoon": "Automatic in less than a day",
      "automatic": "Automatic",
      "title": "Trial",
      "price": "Free for {{days}} days",
      "pointsTitle": "Features",
      "points": {
        "seats": "25 users",
        "ingress": "Ingress limit - unlimited",
        "egress": "Egress limit - unlimited"
      }
    },
    "community": {
      "title": "Community",
      "price": "Free",
      "priceDescription": "Forever",
      "pointsTitle": "Features",
      "points": {
        "seats": "25 users",
        "ingress": "Ingress limit - 10 GB/mo",
        "egress": "Egress limit - 10 GB/mo"
      }
    },
    "pro": {
      "title": "Professional",
      "price": "${{price}}/GB",
      "priceDescription": "Per month",
      "pointsTitle": "Features",
      "points": {
        "seats": "Unlimited users",
        "ingress": "Ingress limit - unlimited",
        "egress": "Egress limit - unlimited"
      },
      "notes": {
        "minCharge": "* Minimum charge ${{minCharge}}"
      }
    },
    "enterprise": {
      "title": "Enterprise",
      "price": "Custom",
      "priceDescription": "Annual Contract",
      "pointsTitle": "Features",
      "points": {
        "seats": "Unlimited users",
        "ingress": "Ingress limit - unlimited",
        "egress": "Egress limit - unlimited"
      }
    }
  },
  "platform": {
    "title": "Simple, transparent pricing",
    "subtitle": "Choose the perfect plan to meet your needs",
    "currentPlan": "Current Plan",
    "header": {
      "currentPlan": "Your Current Plan",
      "billing": "Billing",
      "endingIn": "ending in",
      "noCard": "No card on file",
      "manage": "Manage"
    },
    "community": {
      "title": "Community",
      "price": "Free",
      "retentionPrice": "None",
      "retentionLabel": "Data Retention",
      "ingestionPrice": "Free",
      "ingestionLabel": "Data Ingestion (Uncompressed)",
      "pointsTitle": "Includes:",
      "points": {
        "users": "25 users",
        "liveTail": "Live tail + views",
        "egressLimit": "Egress limit - 10GB/mo*",
        "ingestionLimit": "Ingestion limit - 10GB/mo*",
        "automaticParsing": "Automatic parsing",
        "pipelineLimit": "Limited to 20 pipelines",
        "processorLimit": "Limited to 50 processors per pipeline"
      }
    },
    "pro": {
      "title": "Professional",
      "retention": "{{retention}} days",
      "retentionLabel": "Data Retention",
      "ingestionPrice": "Free",
      "ingestionLabel": "Data Ingestion (Uncompressed)",
      "pointsTitle": "Everything in Community, plus:",
      "points": {
        "unlimitedPipelines": "Unlimited pipelines, sources and destinations",
        "unlimitedProcessors": "Unlimited processors per pipeline",
        "responsivePipelines": "Responsive pipelines",
        "rehydration": "Log data rehydration",
        "alerts": "Alerts via Slack, Email, Webhooks, PagerDuty, and more"
      },
      "notes": {
        "minCharge": "* Minimum charge ${{minCharge}}"
      }
    },
    "enterprise": {
      "title": "Enterprise",
      "retentionPrice": "$0.20 per GB",
      "retentionLabel": "Data Retention (Optional)",
      "retentionPeriod": "30 days",
      "ingestionPrice": "$0.20 per GB",
      "ingestionLabel": "Data Ingestion (Uncompressed)",
      "pointsTitle": "Everything in Professional, plus:",
      "points": {
        "unlimitedUsers": "Unlimited users",
        "multipleOrgs": "Multiple organizations",
        "sso": "SSO and SAML",
        "contracts": "Annual and/or multi-year contracts"
      },
      "contactSales": "Contact Sales"
    }
  }
}